import { zSchema, schemes } from "@zeal/common";

const browserFileSchema =
  typeof File === "undefined" ? zSchema.any() : zSchema.instanceof(File);

export const postCompanyBusinessDocumentsParamsSchema = zSchema.object({
  companyID: schemes.uuid(),
  ein_letter: browserFileSchema.nullable(),
  additional_documents: zSchema.array(browserFileSchema),
  authorized_agent_authorization: browserFileSchema.nullable(),
});

export interface IPostCompanyBusinessDocumentsParams {
  companyID: string;
  ein_letter: File | null;
  additional_documents: File[];
  authorized_agent_authorization: File | null;
}

export const postCompanyBusinessDocumentsResponseSchema = zSchema.object({
  success: zSchema.boolean(),
  message: zSchema.string(),
});

export type TPostCompanyBusinessDocumentsResponse = zSchema.infer<
  typeof postCompanyBusinessDocumentsResponseSchema
>;
